import AppShell from "./AppShell";

// Kept as a thin alias so pages written against the old layout (Calendar,
// Reports) pick up the new shell without edits.
export default function PageContainer({ children }) {
  return <AppShell wide>{children}</AppShell>;
}
